.gridContainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  [data-pill-container] {
    justify-content: start;
    min-width: 116px;
    width: 100%;
  }

  [data-pill-label] {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  [data-asset-header] {
    width: calc(100% - 28px);
  }
}

.root {
  [data-section-header-root] {
    padding-bottom: 4px;
  }
}

.companyItemWrapper {
  width: 25%;
  border-bottom: 1px solid var(--border-soft);
  padding-top: 12px;
  padding-bottom: 4px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.styledButtonLink {
  margin-top: 12px;
}
